import React, { useEffect } from 'react';
import { Colors } from 'library';
import { Link, ResponsiveRow, Stack, Text } from 'library/ui';
import Logo from 'assets/images/WhiteLogo.png';
import { styled } from '@mui/material';

declare global {
    interface Window {
        hbspt: {
            forms: {
                create: (config: { portalId: string; formId: string; region: string; target: string }) => void;
            };
        };
    }
}

export default function LogoRow() {
    useEffect(() => {
        const existingForm = document.querySelector('#hubspot-footer-form > .hs-form');
        if (existingForm) return;

        const script = document.createElement('script');
        script.src = '//js.hsforms.net/forms/embed/v2.js';
        script.async = true;
        script.charset = 'utf-8';
        script.onload = () => {
            if (window.hbspt) {
                window.hbspt.forms.create({
                    portalId: '24317509',
                    formId: '6e773b62-6211-4273-8cc1-0ae3f6e99c39',
                    region: 'na1',
                    target: '#hubspot-footer-form',
                });
            }
        };
        document.body.appendChild(script);
    }, []);

    return (
        <ResponsiveRow collapseAt="md" align="center" justify="between" gap="lg">
            <Spacer />
            <Stack gap="md" align="center">
                <img src={Logo} width={200} alt="logo" />
                <Link href="mailto:support@join-tandem.com" color={Colors.white}>
                    Contact Us
                </Link>
                <Link to="/listings" color={Colors.white}>
                    Jobs
                </Link>
                <Link to="/privacy-policy" color={Colors.white}>
                    Privacy Policy
                </Link>
                <Link to="/tandem-terms-of-use" color={Colors.white}>
                    Terms of Use
                </Link>
                <Text align="center" tone="overlay">
                    PO Box 1058, Columbus, Ohio 43216
                </Text>
            </Stack>
            <Spacer />
            <Hubspot id="hubspot-footer-form" />
        </ResponsiveRow>
    );
}

const Spacer = styled('div')({
    width: 400,
});

const Hubspot = styled('div')({
    width: '100%',
    maxWidth: 600,
});
